import { Button, Select, message } from 'antd'
import React, { useState } from 'react'
import styled from 'styled-components'
import { CircleEditButton } from './Widgets'
import _ from 'lodash'

const Container = styled.div`
  font-size: 20px;
  line-height: 1.5;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;

  button {
    margin-left: 2px !important;
  }
`

const BasicDomains = [
  {
    value: 'muscular_fitness',
    label: 'Muscle Fitness'
  },
  {
    value: 'body_composition',
    label: 'Body Composition'
  },
  {
    value: 'aerobic_fitness',
    label: 'Aerobic Fitness'
  }
]

export const HSDSelector = (props) => {
  const { person, note, handleCommendSave } = props
  const [editing, setEditing] = useState(false)
  const [saving, setSaving] = useState(false)
  const [value, setValue] = useState(note.memo)
  const options =
    person.profile.membership === 'basic'
      ? BasicDomains
      : _.concat(BasicDomains, [
          {
            value: 'joint_fitness',
            label: 'Movement Quality'
          },
          {
            value: 'balance',
            label: 'Balance'
          },
          {
            value: 'cognitive_health',
            label: 'Cognitive Health'
          }
        ])
  return (
    <Container>
      {editing ? (
        <Select
          value={value}
          options={options}
          onChange={(value) => {
            setValue(value)
          }}
        />
      ) : (
        <div>{options.find((i) => i.value === note.memo).label}</div>
      )}
      {editing ? (
        <div>
          <Button
            type="text"
            disabled={saving}
            onClick={() => {
              setEditing(false)
            }}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={async () => {
              setSaving(true)
              try {
                await handleCommendSave(value, note.pillar)
              } catch (error) {
                message.error(error.message)
              } finally {
                setSaving(false)
                setEditing(false)
              }
            }}
            loading={saving}
          >
            Save
          </Button>
        </div>
      ) : (
        <CircleEditButton
          onClick={() => {
            setEditing(true)
          }}
        />
      )}
    </Container>
  )
}
